import React, { useMemo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, IconButton, Stack } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import StyledFormHelperText from "../../../../../Reuse/UI/StyledFormHelperText";
import { useWatch } from "react-hook-form";

const SortableItem = ({ control, id, droneErrors, error, index, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const drone = useWatch({ control, name: `drones.${index}` });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // opacity: isDragging ? 0.5 : 1,
    display: "flex",
    // alignItems: "center",
    flexDirection: "column",
    gap: 6,
  };

  const sx = useMemo(() => {
    if (!!drone.id && drone.isUpdate === false) {
      return { fill: "green" };
    }
    return {};
  }, [drone.id, drone.isUpdate]);

  return (
    <Box ref={setNodeRef} style={style} {...attributes}>
      <Stack direction={"row"} alignItems={"center"} sx={{ width: "100%" }}>
        <IconButton {...listeners} sx={{ cursor: "grab", mr: 0 }}>
          <DragIndicatorIcon sx={sx} />
        </IconButton>
        {children}
      </Stack>
      {!!droneErrors && (
        <StyledFormHelperText
          error={droneErrors}
          id={`${index}`}
          sx={{ marginLeft: 5.5 }}
        >
          {droneErrors}
        </StyledFormHelperText>
      )}
      {!droneErrors && !!error && (
        <StyledFormHelperText
          error={error}
          id={`${index}`}
          sx={{ marginLeft: 5.5 }}
        >
          {error?.message || error?.root?.message}
        </StyledFormHelperText>
      )}
    </Box>
  );
};

export default React.memo(SortableItem);
